import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as bie from "react-bootstrap";
import CommonFormHeading from '../CommonUtils/CommonFormHeading';
import Swal from 'sweetalert2';
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import { config } from '../CommonUtils/CommonURLS';
import { ERROR_MSG } from '../CommonUtils/contextVariables';
import * as Yup from "yup";
import { useEffect, useRef, useState } from 'react';
import { SiMicrosoftexcel } from 'react-icons/si';
import { useDispatch } from 'react-redux';
import { failureAlert, InfoAlert } from '../CommonUtils/SweetAlerts';
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { BiTrash } from "react-icons/bi";
import Excel_sample from "./sample_table.xlsx"

export default function ExcelFileUpload() {
    const validationSchema = Yup.object().shape({
        month: Yup.string().required(ERROR_MSG).nullable(),
        year: Yup.string().required(ERROR_MSG).nullable(),
        file: Yup.string().required(ERROR_MSG).nullable(),


    });
    const [selectedFile, setSelectedFile] = useState(null);


    const ExceluploadFomrik = useFormik({
        initialValues: {
            month: "",
            year: "",
            file: "",
            tableName: "rusa_usha_financials",


        },
        validationSchema: validationSchema,

        onSubmit: async (values) => {
            Swal.fire({
                title: '<span style="font-size: 20px;">Are you sure you want to submit the file?</span>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const formData = new FormData();
                    formData.append("file", selectedFile); // store File object
                    formData.append("tableName", "rusa_usha_financials");
                    formData.append("month", String(values.month))
                    formData.append("year", parseInt(values.year, 10));
                    console.log("payload", formData)

                    try {
                        const url = `${config.url.API_URL}upload-excel`;
                        const res = await CommonAxiosPost(url, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                        if (res?.data != null) {
                            if (res?.data?.status === true) {
                                Swal.fire({
                                    title: res.data.sdesc,
                                    backdrop: false,
                                    icon: "success"
                                }).then((res1) => {
                                    if (res1.isConfirmed) {
                                        ExcelReport();
                                    }
                                });
                            } else {
                                const validationMessages = res.data.validation ? res.data.validation.join('<br>') : res.data.sdesc;
                                Swal.fire({
                                    title: 'Error',
                                    html: validationMessages,
                                    icon: 'warning'
                                }).then(() => {
                                    // Reset form and clear file input
                                    ExceluploadFomrik.resetForm();
                                    setSelectedFile(null);
                                    document.getElementById("file").value = "";
                                });
                            }
                        }
                    } catch (error) {
                        console.error("Submission Failed Due To: ", error);
                        Swal.fire('Error', 'Submission Failed Due To: ' + error, 'error');
                    }
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire('Cancelled', 'Your file has not been uploaded.', 'error');
                }
            });
        }

    });



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        ExceluploadFomrik.setFieldValue('file', file);

        setSelectedFile(file);
    };
    const hasFetchedData = useRef(false)

    const [exceldata, setExceldata] = useState([]);
    const dispatch = useDispatch();

    function ExcelReport() {
        let url = config.url.API_URL + `getExcelData`
        CommonAxiosGet(url, dispatch).then(res => {
            if (res?.data?.scode == "01") {
                setExceldata(res?.data?.data);

            }
            else {
                setExceldata([]);
            }
        })
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            ExcelReport();
            hasFetchedData.current = true
        }
    }, [])
    function DeleteRow(month, year) {
        Swal.fire({
            title: 'Are you sure want to Delete ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                let url = `${config.url.API_URL}deleteExcel?month=${month}&year=${year}`;
                CommonAxiosPost(url, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {
                        Swal.fire(res?.data?.sdesc, '', 'success').then(() => {
                            ExcelReport();
                        });
                    } else {
                        failureAlert(res?.data?.sdesc);
                    }
                });
            }
        });
    }
    const currentMonthIndex = new Date().getMonth(); // 0–11
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const currentMonthValue = String(currentMonthIndex + 1).padStart(2, "0");
    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className='affl-newdiv'>
                <bie.Container fluid className="px-1" >
                    <FormikProvider value={ExceluploadFomrik}>
                        <Form onChange={ExceluploadFomrik?.handleChange} onSubmit={ExceluploadFomrik?.handleSubmit} className="affl-form" >
                            <CommonFormHeading heading={"Excel Upload"} />

                            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                                <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1>Excel Upload</h1>
                                </div>
                                <div className="text-end">
                                    <a href={Excel_sample} download="Sample_Template_Format.xlsx"
                                        style={{ color: "#3234a8ff", fontSize: "18px", fontFamily: "sans-serif" }} >
                                        <SiMicrosoftexcel /> Download Template </a>
                                </div>
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <bie.Alert variant="danger" className='affl-alert' >
                                            <p className="mb-0">Note:  Uploaded Excel column names must match the template. Please download the template for reference.</p>
                                        </bie.Alert>
                                    </bie.Col>

                                </bie.Row>
                                <bie.Row className="my-3 px-3 pt-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2}>
                                        <bie.InputGroup>
                                            <label className="label-text-style mb-1">
                                                <b className='mt-2' style={{ color: 'red' }}>* </b>Select Month
                                            </label>

                                            <Field
                                                as="select"
                                                name="month"
                                                className="form-control"

                                            >
                                                <option value="">--Select--</option>

                                                <option value={currentMonthValue}>
                                                    {monthNames[currentMonthIndex]}
                                                </option>
                                            </Field>

                                            <ErrorMessage name="month" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>

                                    {/* Select Year */}
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} >
                                        <bie.InputGroup>
                                            <label className="label-text-style mb-1">
                                                <b className='mt-2' style={{ color: 'red' }}>* </b>Select Year
                                            </label>
                                            <Field
                                                as="select"
                                                name="year"
                                                className="form-control"

                                            >
                                                <option value="">--Select--</option>
                                                <option value={currentYear}>{currentYear}</option>
                                            </Field>
                                            <ErrorMessage name="year" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>




                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} >
                                        <bie.InputGroup>
                                            <label className="label-text-style" htmlFor="uploadSheet">
                                                <b className='mt-2' style={{ color: 'red' }}>* </b>Upload Excel
                                            </label>
                                            <input
                                                type="file"
                                                id="file"
                                                name="file"
                                                className="form-control"
                                                accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (!file || !file.name.match(/\.(xls|xlsx)$/i)) {
                                                        InfoAlert("Please upload an Excel file (.xls or .xlsx)!");
                                                        e.target.value = "";
                                                        return;
                                                    }
                                                    handleFileChange(e);
                                                }}
                                            />

                                            <ErrorMessage name="file" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} style={{ marginTop: "3%" }} >
                                        <button type="submit" className='btn btn-primary '>
                                            Submit
                                        </button>
                                    </bie.Col>


                                </bie.Row>

                                {exceldata && exceldata?.length > 0 && (
                                    <>
                                        <div className="inner-herbpage-service-title-sub p-0">
                                            <h1 className="mb-0">Excel Report</h1>
                                        </div>
                                        <bie.Row className="px-2 pt-3m-0 mx-1 pt-3 ">
                                            <div className="table-responsive">
                                                <table className="table table-condensed table-bordered table-striped table-sm  table-responsive affl-table">
                                                    <thead>
                                                        <tr>
                                                            <th>S No</th>
                                                            <th>Month</th>
                                                            <th>Year</th>
                                                            <th>File</th>
                                                            <th>Inserted  by</th>
                                                            <th> Inserted time</th>


                                                            <th>Delete</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ textAlign: "center" }}>
                                                        {exceldata !== undefined &&
                                                            exceldata?.map((data, i) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td>{i + 1}</td>
                                                                            <td className='text-left'>{data?.monthName}</td>
                                                                            <td>{data?.year}</td>
                                                                            <td style={{ textAlign: 'center' }}>
                                                                                <a
                                                                                    // href={`https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/${data?.uploadfilepath}`}
                                                                                    href={`${config.url.FILE_DOWNLOAD_URL}${data?.uploadfilepath}`}
                                                                                    target="_self"
                                                                                    rel="noopener noreferrer"
                                                                                    download
                                                                                >
                                                                                    <PiMicrosoftExcelLogoFill size={25} /> Download Excel
                                                                                </a>
                                                                            </td>
                                                                            <td>{data?.uploaded_by} </td>
                                                                            <td className='text-left'>{data?.inserted_time} </td>


                                                                            <td style={{ textAlign: 'center' }}><button type='button' className='btn btn-danger btn-sm' onClick={() => DeleteRow(data?.month, data?.year)}><BiTrash /></button></td>
                                                                        </tr>
                                                                    </>
                                                                );
                                                            })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </bie.Row>
                                    </>
                                )}
                            </bie.Container>
                        </Form>
                    </FormikProvider>
                </bie.Container>
            </div>


        </>)
}